// Friendly status labels for citizens (sökande)
export const CITIZEN_STATUS = {
  inkommet: {
    label: "Vi har tagit emot din ansökan",
    short: "Mottagen",
    description: "Din ansökan är registrerad och väntar på första granskning.",
    classes: "bg-blue-50 text-blue-700 border-blue-200",
    dot: "bg-blue-700",
    icon: "Inbox",
    step: 1,
  },
  komplettering: {
    label: "Vi behöver mer information från dig",
    short: "Inväntar dig",
    description: "Handläggaren har bett om kompletterande uppgifter eller handlingar.",
    classes: "bg-amber-50 text-amber-700 border-amber-200",
    dot: "bg-amber-600",
    icon: "AlertCircle",
    step: 2,
    actionRequired: true,
  },
  beslut: {
    label: "Du har fått beslut",
    short: "Beslut fattat",
    description: "Bygglovet är beviljat eller avslaget. Läs hela beslutet i ärendet.",
    classes: "bg-emerald-50 text-emerald-700 border-emerald-200",
    dot: "bg-emerald-600",
    icon: "CheckCircle2",
    step: 3,
  },
  avslutat: {
    label: "Ditt ärende är avslutat",
    short: "Avslutat",
    description: "Slutbesked är meddelat och ärendet är arkiverat.",
    classes: "bg-zinc-100 text-zinc-700 border-zinc-200",
    dot: "bg-zinc-500",
    icon: "Flag",
    step: 4,
  },
};

export const PROGRESS_STEPS = [
  { key: "inkommet", label: "Inkommen" },
  { key: "komplettering", label: "Granskning" },
  { key: "beslut", label: "Beslut" },
  { key: "avslutat", label: "Slutbesked" },
];

export const APPLICATION_TYPES = [
  { key: "Nybyggnad", title: "Bygga nytt hus", desc: "Helt nytt en- eller flerbostadshus", icon: "Home" },
  { key: "Tillbyggnad", title: "Tillbyggnad", desc: "Bygga ut befintligt hus", icon: "Plus" },
  { key: "Komplementbyggnad", title: "Garage, attefall eller förråd", desc: "Komplementbyggnad upp till 30 kvm", icon: "Warehouse" },
  { key: "Fasadändring", title: "Ändra fasaden", desc: "Byta panel, färg eller fönster", icon: "Paintbrush" },
  { key: "Ändrad användning", title: "Ändra användning", desc: "Lokal till bostad, vind till rum m.m.", icon: "Replace" },
  { key: "Rivning", title: "Rivning", desc: "Riva hela eller delar av en byggnad", icon: "Hammer" },
  { key: "Annat", title: "Annat", desc: "Pool, plank, mur, skylt m.m.", icon: "MoreHorizontal" },
];

export const FAQ_ITEMS = [
  {
    q: "Behöver jag bygglov för att bygga altan eller uteplats?",
    a: "Det beror på höjd och placering. En låg altan (under 1,8 m) nära huset kräver oftast inget bygglov, men en upphöjd uteplats eller med tak kan göra det. Kontakta din kommun för ditt specifika fall.",
  },
  {
    q: "Hur lång är handläggningstiden?",
    a: "Enligt plan- och bygglagen ska bygglov hanteras inom 10 veckor från att ansökan är komplett. För enklare ärenden går det ofta snabbare. Tiden räknas från det datum din ansökan bedöms komplett, inte när du först skickade in.",
  },
  {
    q: "Vad är skillnaden på bygglov och anmälan?",
    a: "Bygglov krävs för större åtgärder som nybyggnad, tillbyggnad och fasadändring. Anmälan räcker för t.ex. attefallshus, eldstad eller installation av vatten/avlopp. Båda hanteras via denna tjänst.",
  },
  {
    q: "Vilka handlingar behöver jag bifoga?",
    a: "Standard är: situationsplan (visar var byggnaden ska stå), planritning (rum och mått), fasadritning (alla sidor av huset) och sektionsritning. Skala 1:100 eller 1:400 för situationsplan. PDF eller skannade ritningar i god kvalitet.",
  },
  {
    q: "Vad händer om jag bygger utan bygglov?",
    a: "Då kan kommunen besluta om byggsanktionsavgift, krav på rivning eller efterhandsprövning. Avgifterna är betydande – det är alltid billigast att söka lov först.",
  },
  {
    q: "Kan jag ändra min ansökan efter att jag skickat in?",
    a: "Ja. Innan beslut fattas kan du komplettera eller dra tillbaka din ansökan. Skicka ett meddelande till din handläggare via ärendet så hjälper de dig.",
  },
];

export function friendlyStatus(status) {
  return CITIZEN_STATUS[status] || { label: status, short: status, classes: "bg-zinc-100 text-zinc-700 border-zinc-200", step: 0 };
}
